import React from "react";
import { Card, CardContent, Box, Typography, Divider } from "@mui/material";

const ChartCard = ({ title, subtitle, title2, subtitle2, children }) => (
  <Card
    className="bg-white !rounded-lg border border-slate-200 !shadow-none h-full"
    sx={{ height: "100%", display: "flex", flexDirection: "column" }}
  >
    <CardContent
      sx={{ flexGrow: 1, display: "flex", flexDirection: "column" }}
      className="!py-2 !px-2"
    >
      <Box className="flex items-start justify-between">
        <Box>
          <Typography
            variant="body1"
            fontWeight="bold"
            className="!text-gray-600"
          >
            {title}
          </Typography>
          <Typography variant="body2" className="!text-gray-800" gutterBottom>
            {subtitle}
          </Typography>
        </Box>
        <Box>
          <Typography
            variant="body1"
            fontWeight="bold"
            className="!text-gray-600"
          >
            {title2}
          </Typography>
          <Typography variant="body2" className="!text-gray-800" gutterBottom>
            {subtitle2}
          </Typography>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        {children}
      </Box>
    </CardContent>
  </Card>
);

export default ChartCard;
